/**
 * This is the initial state of the module. It is used to create a new module
 * or to reset the module to its initial state.
 * keys that have the Es suffix will automatically be translated to Spanish upon module creation / update based on the english key value.
 * @type {Object}
 */
export const initialModuleState = Object.freeze({
    title: "",
    titleEs: "",
    image: "",
    description: "",
    descriptionEs: "",
    category: "",
    categoryEs: "",
    whatLearn: "",
    whatLearnEs: "",
    directions: "",
    directionsEs: "",
    type: "NACE",
    skills: [],
    skillsEs: [],
    fullDescription: "",
    fullDescriptionEs: "",
    time: "",
    timeEs: "",
    quote: "",
    quoteEs: "",
    quoteAuthor: "",
    image: "",
    shortDescription: "",
    shortDescriptionEs: "",
    internalNotes: "",
    sections: [
      {
        sectionTitle: "",
        sectionTitleEs: "",
        sectionTime: "",
        sectionTimeEs: "",
        sectionDescription: "",
        sectionDescriptionEs: "",
        sectionDirections: "",
        sectionDirectionsEs: "",
        sectionSlides: [
          {
            slideTitle: "",
            slideTitleEs: "",
            slideContent: [
            ],
          },
        ],
      },
    ],
  })